import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  presentToast(message: string, type = 'success') {
  }

  success(message: string) {
    this.presentToast(message, 'success');
  }

  error(message: string) {
    this.presentToast(message, 'error');
  }

  info(message: string) {
    this.presentToast(message, 'info');
  }

  warning(message: string) {
    this.presentToast(message, 'warning');
  }
}
